import React from "react";
import { useNavigate } from "react-router-dom";

const MnuSupport = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-slate-950 text-white">
      <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 md:px-8">
        <div className="rounded-3xl border border-white/10 bg-slate-900/80 p-8 shadow-2xl backdrop-blur-md">
          <h1 className="mb-6 text-4xl font-extrabold text-emerald-300 md:text-5xl">
            Support, der Orientierung gibt
          </h1>

          <p className="mb-10 max-w-3xl text-lg text-slate-200/90">
            Experts4Europe soll nicht verwirren, sondern begleiten. Deshalb sind die wichtigsten Bereiche klar
            strukturiert, verständlich benannt und auf internationale Nutzer ausgerichtet.
          </p>

          <section className="mb-12">
            <h2 className="mb-3 text-2xl font-bold text-white md:text-3xl">Wobei wir helfen</h2>
            <ul className="list-disc space-y-4 pl-6 text-slate-200/90">
              <li><strong>Profil und Bewerbung:</strong> Verstehe, was schon stark ist und was noch fehlt.</li>
              <li><strong>Sprachtest:</strong> Arbeite fokussiert am B1-Bereich ohne überladene Zusatzmodule.</li>
              <li><strong>Chancen:</strong> Sieh passende Jobs, neue Signale und deinen nächsten sinnvollen Schritt.</li>
              <li><strong>Konto und Sicherheit:</strong> Sitzungen, Einstellungen und geschützte Bereiche bleiben nachvollziehbar.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="mb-3 text-2xl font-bold text-white md:text-3xl">Wie Support gedacht ist</h2>
            <ul className="list-disc space-y-4 pl-6 text-slate-200/90">
              <li><strong>Klare Sprache:</strong> Weniger Fachbegriffe, mehr verständliche Hinweise.</li>
              <li><strong>Direkte Aktionen:</strong> Die Plattform zeigt, wo du konkret weitermachen kannst.</li>
              <li><strong>Ein System:</strong> Dashboard, Bewerbung, Sprachtest und Erfolge gehören sichtbar zusammen.</li>
            </ul>
          </section>

          <div className="mt-12">
            <button
              onClick={() => navigate(-1)}
              className="rounded-xl bg-emerald-600/80 px-6 py-2 text-lg font-bold text-white shadow-xl transition duration-300 ease-in-out hover:bg-emerald-500/80"
            >
              Zurück
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MnuSupport;
